<template>
  <v-select
    v-model="$data[opts.key]"
    :name="opts.key"
    :items="moduleProducts"
    multiple
    :item-text="'name'"
    :item-value="'id'"
    :label="label"
    :placeholder="opts.placeholder || $t('bots.selectField') + ' ' + label"
    :error-messages="errorMessages"
    @change="$v[opts.key].$touch()"
    @blur="$v[opts.key].$touch()"
  >
    <template #append>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-icon v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        {{ description }}
      </v-tooltip>
    </template>
  </v-select>
</template>
<script>
import {validationMixin} from "vuelidate";
import {requiredIf} from "vuelidate/lib/validators";
import PRODUCTS_QUERY from "@/graphql/queries/modules/Products.gql";
import {mapGetters} from 'vuex';

export default {
  name: "Products",
  mixins: [validationMixin],
  props: {
    opts: {
      type: Object,
      required: true
    },
    config: {
      type: [Object, Array, null],
      default() {
        return null;
      }
    }
  },
  data() {
    let data = {};
    let key = this.opts.key;
    // if (this.opts.multiple) {
    data[key] = this.opts.value ? [...this.opts.value] : [];
    // }
    // else {
    //   data[key] = this.opts.value || null;
    // }
    return data;
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    label() {
      return (
          this.opts.name[this.$i18n.locale] +
          (this.opts.required != undefined && this.opts.required == true
              ? "*"
              : "")
      );
    },
    description() {
      return this.opts.description[this.$i18n.locale];
    },
    errorMessages() {
      const errors = [];
      if (this.$v[this.opts.key] != undefined) {
        if (!this.$v[this.opts.key].$dirty) return errors;
        this.$v[this.opts.key].required !== undefined &&
        !this.$v[this.opts.key].required &&
        errors.push(this.$t("profile.reqField"));
      }
      return errors;
    },
    optionsItems() {
      return this.opts.values ? this.opts.values.map(item => {
        return {
          id: item.id,
          name: item.name[this.$i18n.locale]
        }
      }) : [];
    }
  },
  watch: {
    opts: {
      handler({value, key}) {
        if (value && key) {
          this[key] = value;
        }
      },
      deep: true,
      immediate: true
    },
    config: {
      handler(newConfig) {
        // console.log(newConfig);
        if (this.opts.multiple && !Array.isArray(newConfig)) {
          this.$data[this.opts.key] = newConfig;
        } else {
          this.$data[this.opts.key] = newConfig;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {},
  validations() {
    let validation = {};
    if (this.opts.validate != undefined && !_.isEmpty(this.opts.validate)) {
      validation[this.opts.key] = {
        required: requiredIf(() => this.opts.validate.includes("required"))
      };
    }
    return validation;
  },
  apollo: {
    moduleProducts: {
      fetchPolicy: "network-only",
      query() {
        return PRODUCTS_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.getWhiteLabel.uuid
        }
      },
      skip() {
        return !this.getWhiteLabel.uuid;
      },
    },
  },
};
</script>
